import { fetchOptions } from './csrf'

export interface BannerSetting {
  id: string | null
  enabled: boolean
  banner_text: string | null
  position: string
  background_color: string | null
  text_color: string | null
  font_size: number | null
  created_at: string | null
  updated_at: string | null
}

interface BannerSettingResponse {
  banner_setting: BannerSetting
}

interface ErrorResponse {
  errors: string[]
}

export const bannerSettingsApi = {
  async show(): Promise<BannerSetting> {
    const response = await fetch('/api/v1/settings/banner', fetchOptions())
    if (!response.ok) throw new Error('Failed to load banner settings')
    const data: BannerSettingResponse = await response.json()
    return data.banner_setting
  },

  async update(params: Partial<Omit<BannerSetting, 'id' | 'created_at' | 'updated_at'>>): Promise<BannerSetting> {
    const response = await fetch('/api/v1/settings/banner', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ banner_setting: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update settings'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: BannerSettingResponse = await response.json()
    return data.banner_setting
  },
}
